itsoftApp.createModule("search", ["hiddenLabel"], function () {
    var form = document.querySelector(".js-search-form");
    var searchInput = document.querySelector(".js-search-input");
    var searchOptions = document.querySelector(".js-search-options");

    var searchOptionsList = document.querySelector(".js-search-options-list");
    var searchButton = document.querySelector(".js-search-button");
    var count = document.querySelector(".js-results-count");

    var searchResults = document.querySelector(".js-search-results");
    var searchNoResults = document.querySelector(".js-search-no-results");
    var searchResultsList = document.querySelector(".js-search-results-list");
    var currentData;
    var submitFlag = false;

    var onSuccessLoad = function (data) {
        currentData = data;
        var wrapper = document.createElement("div");
        wrapper.innerHTML = currentData;
        var newSearchList = wrapper.querySelector(".js-search-options-list");
        var liElements = newSearchList.querySelectorAll("li");

        if (liElements.length > 0) {
            newSearchList.classList.add("js-show");
        } else {
            newSearchList.classList.remove("js-show");
        }

        if (searchOptionsList) {
            searchOptions.removeChild(searchOptionsList);
        }

        searchOptions.appendChild(newSearchList);
        searchOptionsList = document.querySelector(".js-search-options-list");
    }


    var debouncerResultQuery = function (evt) {
        evt.preventDefault();
        itsoftApp.utils.loadBlock(searchInput.value, onLoadSearchResult);
    }



    if (searchButton) {
        form.onsubmit = function (evt) {
            evt.preventDefault();
            var submitData;

            var value = DEBUG ? "/ajax/search_suggest.php" : "/ajax/search_suggest.php?q=" + searchInput.value;
            value.replace(/\s/g, '+');

            var onSubmitLoad = function (data) {
              submitData = data;

              if (submitData && !submitFlag) {
                  submitFlag = true;

                  if (searchInput.value != "") {
                      var wrapper = document.createElement("div");
                      wrapper.innerHTML = submitData;
                      var newResultsList = wrapper.querySelector(".js-search-results-list");
                      var liElements = newResultsList.querySelectorAll("li")
                      var lengthEls = liElements.length;
                      count.textContent = lengthEls;

                      if (searchResultsList) {
                          searchResults.removeChild(searchResultsList);
                      }

                      searchResults.appendChild(newResultsList);
                      searchResultsList = document.querySelector(".js-search-results-list");

                      if (lengthEls > 0) {
                          searchNoResults.classList.remove("js-show");
                          searchResults.classList.add("js-show");
                      } else {
                          searchNoResults.classList.add("js-show");
                          searchResults.classList.remove("js-show");
                      }
                  } else {
                      searchNoResults.classList.add("js-show");
                      searchResults.classList.remove("js-show");
                  }

                  submitFlag = false;
              }
            }

            itsoftApp.utils.loadBlock(value, onSubmitLoad);
        }
    }

    if (searchInput) {
        var debouncerQuery = itsoftApp.utils.debouncer(function () {
          var value = DEBUG ? "/ajax/search_suggest.php" : "/ajax/search_suggest.php?q=" + searchInput.value;
          value.replace(/\s/g, '+');
          history.pushState("", "", "?q=" + searchInput.value)

          itsoftApp.utils.loadBlock(value, onSuccessLoad);
        }, 1000);

        searchInput.addEventListener("focus", function () {
            if (searchOptions) {
                searchOptions.classList.add("js-show");
            }
          });

      searchInput.addEventListener("blur", function () {
        setTimeout(function () {
            if (searchOptions) {
                searchOptions.classList.remove("js-show");
            }
        }, 300)
      });

      searchInput.addEventListener("input", debouncerQuery);
    }
});